import SwitchFilter from "./ActivationFilter";
import TableSearchInput from "./TableSearchInput";

const FilterTable = ({ column }) => {
  const { filterVariant, switchOptions } = column.columnDef.meta ?? {};

  const columnFilterValue = column.getFilterValue();

  const filterType = {
    text: (
      <TableSearchInput column={column} columnFilterValue={columnFilterValue} />
    ),
    switch: <SwitchFilter column={column} options={switchOptions} />,
  };

  return <div>{filterType[filterVariant]}</div>;
};

export default FilterTable;
